import React from "react";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import "../Css/Navbar.css";

// ===== IMPORT LOGO =====
import logo from "../Assets/logo.png";

const Navbar = () => {

  // ===== SCROLL FUNCTION =====
  const scrollToSection = (id) => {

    // ===== CLOSE OFFCANVAS FIRST =====
    const offcanvasElement =
      document.getElementById("mobileMenu");

    if (offcanvasElement) {

      const bsOffcanvas =
        Offcanvas.getInstance(offcanvasElement);

      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }

    // ===== SCROLL AFTER DELAY =====
    setTimeout(() => {

      const section =
        document.getElementById(id);

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

    }, 300);
  };

  return (
    <>
      {/* ===== NAVBAR ===== */}
      <nav className="navbar navbar-expand-lg custom-navbar">

        <div className="container-fluid navbar-container">

          {/* ===== LOGO ===== */}
          <div
            className="logo-section"
            onClick={() => scrollToSection("home")}
          >

            {/* LOGO IMAGE */}
            <img
              src={logo}
              alt="EliteNova Logo"
              className="navbar-logo"
            />

            {/* LOGO TEXT */}
            <h2 className="logo-text">
              EliteNova
            </h2>

          </div>

          {/* ===== MOBILE TOGGLER ===== */}
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
            aria-controls="mobileMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* ===== DESKTOP MENU ===== */}
          <div className="desktop-menu">

            <ul className="nav-links">

              <li>
                <button
                  onClick={() =>
                    scrollToSection("about")
                  }
                >
                  About
                </button>
              </li>

              <li>
                <button
                  onClick={() =>
                    scrollToSection("services")
                  }
                >
                  Services
                </button>
              </li>

              <li>
                <button
                  onClick={() =>
                    scrollToSection("products")
                  }
                >
                  Products
                </button>
              </li>

              <li>
                <button
                  onClick={() =>
                    scrollToSection("contact")
                  }
                >
                  Contact
                </button>
              </li>

            </ul>

          </div>

        </div>
      </nav>

      {/* ===== MOBILE OFFCANVAS ===== */}
      <div
        className="offcanvas offcanvas-end custom-offcanvas"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >

        {/* ===== OFFCANVAS HEADER ===== */}
        <div className="offcanvas-header">

          <div className="mobile-logo-wrapper">

            <img
              src={logo}
              alt="EliteNova Logo"
              className="mobile-navbar-logo"
            />

            <h5
              className="offcanvas-title"
              id="mobileMenuLabel"
            >
              EliteNova
            </h5>

          </div>

          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>

        </div>

        {/* ===== OFFCANVAS BODY ===== */}
        <div className="offcanvas-body">

          <ul className="mobile-links">

            <li>
              <button
                onClick={() =>
                  scrollToSection("about")
                }
              >
                About
              </button>
            </li>

            <li>
              <button
                onClick={() =>
                  scrollToSection("services")
                }
              >
                Services
              </button>
            </li>

            <li>
              <button
                onClick={() =>
                  scrollToSection("products")
                }
              >
                Products
              </button>
            </li>

            <li>
              <button
                onClick={() =>
                  scrollToSection("contact")
                }
              >
                Contact
              </button>
            </li>

          </ul>

        </div>
      </div>
    </>
  );
};

export default Navbar;